// var swiper = new Swiper(".mySwiper", {
//       slidesPerView: 1,
//       spaceBetween: 30,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//     });



window.ShopTheLookSettingsV2 = {
    shopUrl: '3795f1-44.myshopify.com',
    isEnabled: true,
    definedTemplate: 'in_desc',
    isWidget: false,
    cartTokenInsertUrl: 'https://shopify.shopthelook.app/cart_token/insert',
    revenueTrackingUrl: 'https://shopify.shopthelook.app/revenue',
    cartPageCssSelector: '',
    isShownOnCartPage: 'false',
    mainProductId: '9234882691414',
    mainButtonColor: "000",
    mainButtonHoverStyle: "",
    mainButtonCustomCss: "",
    mainButtonAfterSectionSelector: "",
    customTitle: "COMPLETE YOUR LOOK",
    shopCollectionsHandle: '',
    isCenterOnDesktop: 'false',
    products_count: 3,
    show_button: false,
    popup_autoload: false,
    jQueryUrl: 'https://cdn.shopify.com/extensions/f04c5551-3edb-492a-be4f-ba28a3ecb810/shop-the-look-46/assets/jquery.min.js',
};

// jQuery ready function
$(document).ready(function() {
    const $sliderItems = $('.stl__product'); // Adjust this selector to your slider items
    let currentIndex = 0;

    function updateSlider() {
        $sliderItems.hide(); // Hide all items
        $sliderItems.eq(currentIndex).show(); // Show current item
    }

    // Next button click event
    $('#slider-next').click(function() {
        currentIndex = (currentIndex + 1) % $sliderItems.length; // Loop back to the start
        updateSlider();
    });

    // Prev button click event
    $('#slider-prev').click(function() {
        currentIndex = (currentIndex - 1 + $sliderItems.length) % $sliderItems.length; // Loop back to the end
        updateSlider();
    });

    // Initial display
    updateSlider();
});






    